
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"66","height":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#f8f8f8","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M.018 43.59zm.039-.3c.794-6.177 1.663-15.7 2.424-21.508q1.137-8.674 2.234-17c1.178-8.943 9.6-2.736 11.586-2.107a6.27 6.27 0 00-1.724 2.392q-3.388 8.822-6.907 18.021L.333 42.276a5.2 5.2 0 00-.277 1.015z"}}),_c('path',{attrs:{"d":"M24.648.13c2.35.248 6.223 7.549 25.8 2.714l11.681 1.229c2.785.293 4.421 2.538 3.7 5.006q-2 6.818-4.05 13.861-2.079 7.154-4.241 14.542c-.8 2.747-3.967 5.283-7.139 5.634L30.973 45.27 7.049 47.923c-5.005.555-8.106-1.989-6.717-5.642q3.729-9.807 7.337-19.188 3.517-9.2 6.907-18.021C15.797 1.891 20.402-.318 24.648.13zm-3.791 32.193a11.246 11.246 0 00-.663 2.98 4 4 0 002.394 4.175c1.656.8 4.149 1.059 7.432.8.91-.076 1.886-.194 2.92-.364.18 0 1.579-.238 3.131-.558a28.157 28.157 0 004.061-1.073l1.626-5.355a29.259 29.259 0 01-5.884 1.095c-2.332-.022-3.435-.8-3.25-2.347a3.447 3.447 0 01.166-.681l1.318-3.611a48.091 48.091 0 012.206-4.967c1.754-1.4 5.174-2.293 8.077-2.821 2.836-.515 5.2-.689 5.2-.689q.853-2.19 1.729-4.424l-3.433.019c-1.155.006-2.349.014-3.545.022q-2.613.017-5.314.03c.353-.928-.356.939 0 0l.885-2.334q.581-1.528 1.17-3.085a28.747 28.747 0 01-9.444-.631 20.262 20.262 0 01-2.469-.8q-2.176 6.472-4.242 12.576-2.091 6.193-4.07 12.048z"}})])])
          )
        }
      }
    